// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRoutingTimings" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const ChatRoutingTimingsGenShape = z.strictObject({
  totalMs: z.number(),
  resolveMs: z.number().optional(),
  joinMs: z.number().optional(),
  contentMs: z.number().optional(),
  scoringMs: z.number().optional(),
});
